import { Flex } from "@radix-ui/themes";
import cx from "classnames";
import { type ComponentProps } from "react";

type PageHeaderProps = ComponentProps<"div">;

export function PageHeader({ children, className, ...rest }: PageHeaderProps) {
  return (
    <Flex
      align="center"
      gap="1"
      data-testid="page-header"
      className={cx(
        // `relative z-10` is required: `backdrop-blur-sm` below creates its
        // own stacking context, so absolutely-positioned dropdowns inside the
        // header (participants combobox, "New" menu, etc.) cannot `z-50`
        // their way over the following `<article>` unless the header itself
        // sits on a higher layer than the article. Without this, filter /
        // role dropdowns render visually on top but the article intercepts
        // clicks against any option whose center sits over article content.
        "relative z-10 h-14 shrink-0 border-b border-puntt-neutral-gray-4 bg-base-white/90 px-5 backdrop-blur-sm",
        className,
      )}
      {...rest}
    >
      {children}
    </Flex>
  );
}
